module.exports = __webpack_public_path__ + "static/media/dipping.1e38aafe.mp4";